/* @flow */

import 'CoreUtils/Polyfills';
import React from 'react';
import ReactDOM from 'react-dom';
import { createStore, applyMiddleware, combineReducers } from 'redux';
import { Provider } from 'react-redux';
import type { $WidgetSettings } from './types';
import thunk from 'redux-thunk';
import reducers from './store';
import WidgetBase from './WidgetBase';
import { trackingSearchMiddleware } from './store/tracking';
/* $FlowFixMe */
import { applyPolyfills, defineCustomElements } from 'workbench-core/dist/loader';

class Widget {
  settings: $WidgetSettings;

  init(settings: $WidgetSettings): void {
    this.settings = settings;
  }

  render() {
    applyPolyfills()
      .then(() => defineCustomElements(window))
      .then(this.bootstrap);
  }

  bootstrap = () => {

    const middleware = [
      thunk,
      trackingSearchMiddleware
    ];

    const store = createStore(
      combineReducers({ dsw: reducers }),
      {
        dsw: {
          settings: this.settings
        }
      },
      applyMiddleware(...middleware)
    );

    const { element, ...propSettings } = this.settings;
    const _element: ?HTMLElement = typeof element === 'string'
      ? document.getElementById(element)
      : element;
    if (_element instanceof HTMLElement) {
      ReactDOM.render(
        <Provider store={store}>
          <WidgetBase settings={propSettings} />
        </Provider>,
        _element
      );
    }
  }

  destroy = () => {
    const element: ?HTMLElement = typeof this.settings.element === 'string'
      ? document.getElementById(this.settings.element)
      : this.settings.element;
    if (element instanceof HTMLElement) {
      ReactDOM.unmountComponentAtNode(element);
    }
  };
}

export default Widget;
